import { render, staticRenderFns } from "./BotManagePosts.vue?vue&type=template&id=6debc420&"
import script from "./BotManagePosts.vue?vue&type=script&lang=js&"
export * from "./BotManagePosts.vue?vue&type=script&lang=js&"
import style0 from "./BotManagePosts.vue?vue&type=style&index=0&id=6debc420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports